<!-- MENU INFERIOR -->
<div class="menu-lateral d-inline d-lg-none" [ngClass]="{ 'active': menuActive }">

    <div class="fondo" (click)="cerrarMenu()"></div>

    <div class="caja ">

        <!-- Superior -->
        <div class="px-5 pb-3 pt-5">

            <!-- Está logueado -->
            <div *ngIf="isLogged">
                <h5><strong>Bienvenido/a {{usuario?.firstName}}</strong>
                </h5>


                <span *ngIf="!hasSuscription" class="text-muted">Suscríbete ahora para tener las mejores películas en la
                    palma de tu mano</span>

                <div class="d-flex flex-strech mt-3">
                    <button *ngIf="isLogged && !hasSuscription" class="btn cm-bg-color-11 px-4 text-white rounded-0"
                        routerLink="./suscripcion">Suscribirme
                    </button>
                    <span class="rounded-0 tipoDeSub" *ngIf="isLogged && hasSuscription">
                        {{usuario?.suscription?.subscriptionPlan}}
                    </span>

                    <!-- <button class="btn cm-bg-color-11 px-4 text-white rounded-0" routerLink="suscripcion"
                        *ngIf="isLogged && hasSuscription">
                        {{usuario?.suscription.subscriptionPlan}}
                    </button> -->

                </div>

            </div>

            <!-- No está logueado -->
            <div *ngIf="!isLogged">
                <h5><strong>Bienvenido/a </strong> </h5>

                <span class="text-muted">Inicia sesión para disfrutar de nuestra selección.</span>

                <div class="d-flex flex-strech mt-3">
                    <button class="btn btn-primary mr-3" (click)="abrirLogin()">Ingresar</button>
                    <button class="btn btn-outline-primary" (click)="abrirRegistro()">Registrate</button>
                </div>
            </div>


            <!-- Google Play -->
            <button class="btn btn-outline-light p-3 px-4 mt-4" (click)="descargarApp()">
                <i class="fab fa-google-play mr-2"></i> Descargar App </button>


        </div>

        <!-- Divisor -->
        <div class=" px-4 ">
            <hr class="mb-4 w-100 cm-bg-white-15">
        </div>

        <!-- Items -->
        <ul class="list-group  mb-2">

            <li *ngIf="isLogged" class="list-group-item">
                <a class="px-5 py-3 text-white" (click)="cerrarMenu()" href="/cuenta">
                    Mi cuenta
                </a>
            </li>

            <div *ngFor="let item of menuItems">
                <!-- Lista -->
                <li class="list-group-item" *ngIf="item.type == 'lista'">
                    <a class="dropdown-toggle px-5 py-3 text-white" data-toggle="collapse" href="#menuCollapse"
                        role="button" aria-expanded="false" aria-controls="menuCollapse">
                        {{ item.name }}
                    </a>

                    <div class="collapse menu-collapse" id="menuCollapse">
                        <div class="card card-body p-0">
                            <ul class="list-group">
                                <li class="list-group-item p-0 pl-5" *ngFor="let subItem of item.list"
                                    (click)="cerrarMenu()">

                                    <!-- RouterLink -->
                                    <a class="px-4 py-2  border-left cm-tx-white-50"
                                        *ngIf="item.listType == 'routerLink'" routerLink="{{ subItem.url }}">
                                        {{ subItem.name }}</a>

                                    <!-- Normal -->
                                    <a class="px-4 py-2  border-left cm-tx-white-50" *ngIf="item.listType == 'normal'"
                                        href="{{ subItem.url }}">{{ subItem.name
                                        }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </li>

                <!-- RouterLink -->
                <li class="list-group-item" *ngIf="item.type == 'routerLink'" routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <a class="px-5 py-3 text-white" routerLink="{{ item.path }}" (click)="cerrarMenu()">{{ item.name
                        }}</a>
                </li>

                <!-- Normal -->
                <li *ngIf="item.type == 'normal'" class="list-group-item">
                    <a class="px-5 py-2 text-white" href="{{ item.path }}" (click)="cerrarMenu()">{{ item.name
                        }}</a>
                </li>
            </div>

        </ul>

        <!-- Abajo - Cerrar sesión -->
        <div *ngIf="isLogged">

            <!-- Divisor -->
            <div class=" px-4 ">
                <hr class="mb-4 w-100 cm-bg-white-15">
            </div>


            <div class="px-5 py-2  mt-4 mb-5">
                <a class="text-white text-muted" (click)="cerrarSesion()">
                    <i class="fas fa-sign-out-alt flip-horizontal mr-3"></i> Cerrar sesión
                </a>
            </div>

        </div>

        <!-- <ul class="list-group mb-4" *ngIf="isLogged">
                <li class="list-group-item" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a routerLink="/cuenta" (click)="menu_alternar(false)">Cuenta</a>
                </li>
                <li class="list-group-item">
                    <a href="#" (click)="cerrarSesion()"> Cerrar sesión </a>
                </li>
            </ul> -->
    </div>

</div>